import { render, staticRenderFns } from "./KCW_SettingsWindow.vue?vue&type=template&id=b6c22e0a&scoped=true"
import script from "./KCW_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./KCW_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c22e0a",
  null
  
)

export default component.exports